import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CorrectionStartPayload, CorrectionStartResponse } from '../../../recommendations';
import api from '../../http';
import { toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export function usePostAdviceCorrectionStart() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();
	return useMutation<CorrectionStartResponse, Error, CorrectionStartPayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<CorrectionStartResponse>(
					'/advices/planting/iniciarRecomendacao',
					payload,
					{
						params: { forBinding },
					}
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao iniciar a recomendação de correção');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['correction'] });
		},
	});
}
